import { useEffect } from 'react';
import { useHousehold } from './useHousehold';
import { useToast } from '../components/ui/Toast';

const NOTIF_KEY = 'hs_push_notifications';
const NOTIF_SEEN_KEY = 'hs_premium_notif_seen';

function daysBetween(dateStr: string): number {
  const now = new Date();
  const target = new Date(dateStr);
  const diffMs = target.getTime() - now.getTime();
  return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
}

function todayStr(): string {
  return new Date().toISOString().slice(0, 10);
}

export function usePremiumNotifications() {
  const { data: household } = useHousehold();
  const { addToast } = useToast();

  useEffect(() => {
    if (!household?.premiumUntil) return;
    try {
      if (localStorage.getItem(NOTIF_KEY) === 'false') return;
    } catch { return; }

    const days = daysBetween(household.premiumUntil);
    if (days !== 0 && days !== 3 && days !== 7) return;

    const seenKey = `${NOTIF_SEEN_KEY}_${todayStr()}_${days}`;
    try {
      if (localStorage.getItem(seenKey)) return;
      localStorage.setItem(seenKey, '1');
    } catch { /* ignore */ }

    if (days === 0) {
      addToast('Seu plano Premium expira hoje!', 'error');
    } else if (days === 3) {
      addToast('Seu Premium expira em 3 dias.', 'info');
    } else if (days === 7) {
      addToast('Seu Premium expira em 7 dias.', 'info');
    }
  }, [household?.premiumUntil, addToast]);
}
